// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   balance: 0,
//   assigned_limit: 0,
//   amount: 0,
//   duedate: "",
//   is_paid: "Unpaid",
//   currency_sym: "₹",
//   transactions: [],
// };

// const creditSlice = createSlice({
//   name: "credit",
//   initialState,
//   reducers: {
//     setCreditData: (state, action) => {
//       return { ...state, ...action.payload };
//     },
//   },
// });

// export const { setCreditData } = creditSlice.actions;
// export default creditSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: 0,
  assigned_limit: 0,
  amount: 0,
  duedate: "",
  is_paid: "Unpaid",
  currency_sym: "₹",
  transactions: [],
};

const creditSlice = createSlice({
  name: "credit",
  initialState,
  reducers: {
    // setCreditData: (state, action) => {
    //   return { ...state, ...action.payload };
    // },
    setCreditData: (state, action) => {
  const updated = { ...state, ...action.payload };
// console.log(updated,"updated")
  //  Prevent negative balance always
  if (updated.data < 0) {
    updated.data = 0;
  }

  return updated;
},
  setDefaultCreditData:(state,action)=>{
return initialState
}
  },
});

export const { setCreditData,setDefaultCreditData } = creditSlice.actions;
export default creditSlice.reducer;
